import React, { useState, useRef, useEffect} from "react";     //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
import styles from './videoCallChat.module.css';
//import Grid from '@mui/material/Grid';
import Grid from '@mui/material/Unstable_Grid2';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';

function VideoCallChat(props) {
  const [messages, setMessages] = useState([]);          //Equivalent of this moved to VideoCallPage as the data is lost when the component re-renders on clicking {styles.show_chat_button.
  const [newMessage, setNewMessage] = useState('');      //Equivalent of this moved to VideoCallPage as the data is lost when the component re-renders on clicking {styles.show_chat_button.

  //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  // 'useRef' is hook like 'useState'.
  // In summary, useRef is a way to persistently store a mutable value across renders in a React component, and it's commonly used for accessing and interacting with DOM elements.
  const textareaRef = useRef(null);   // By using the ref in the textarea element, you are creating a reference to that specific textarea instance. This allows you to access and manipulate the DOM properties and methods associated with that textarea, such as scrollHeight.

  //--------------------------------- TIME ---------------------------------------
  /*
  //If you want 24 hour format clock.
  const getCurrentTime = () => {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  };*/

  const getCurrentTime = () => {
    const now = new Date();     // The output format - 'Fri Feb 16 2024 19:55:42 GMT+0530 (India Standard Time)'
    let hours = now.getHours();   // Get the hours in 24 hours format i.e a number from 0 to 23.
    const ampm = hours >= 12 ? 'PM' : 'AM';
  
    hours = (hours % 12) || 12; // Convert 24-hour format to 12-hour format
    const formattedHours = hours.toString().padStart(2, '0');    // It will make it '04' from '4'.
    const minutes = now.getMinutes().toString().padStart(2, '0');   // It will make it '04' from '4'.
  
    return `${formattedHours}:${minutes} ${ampm}`;
  };  
  //-----------------------------------------------------------------------------

  // The below code is for the making the textarea dynamically increase as we type.
  useEffect(() => {          //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    // Update the textarea height whenever the text changes
    if (textareaRef.current) {
      //console.log(textareaRef.current);
      // textareaRef.current.style.height = 'auto';              //Unecessary...... Reset height to auto.
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set height based on content.  //Didn't understand why exactly we are doing it like this instead of directly giving 'auto' here.
    }
  }, [newMessage]);       // Only re-run the effect if "newMessage" state changes. It's an array. So I guess you can give multiple states.

  const handleInputChange = (e) => {
    setNewMessage(e.target.value);
  };

  const handleSendMessage = () => {
    if (newMessage.trim() === '') return;

    const currentTime = getCurrentTime();
    setMessages([{ text: newMessage, sender: 'local_user', time: currentTime },...(messages)]);
    
    setNewMessage('');
  };

  return (
    <Grid xs={props.show_chat_vcc ? 3 : 0} className={props.show_chat_vcc ? `${styles.chat_grid_container}` : `${styles.chat_grid_container_hidden}`} spacing={0} >
      <div className={styles.chat_container}>
        <div className={styles.chat_messages}>
          {messages.map((message, index) => (
            <div key={index} className={`${styles.message} ${message.sender}`}>
              <div className={styles.message_text}>{message.text}</div>
              <div className={styles.message_time_div}>
                <span className={styles.message_time}>{message.time}</span>
              </div>
            </div>
          ))}
        </div>
        <div className={styles.chat_input}>
          <textarea
            ref={textareaRef}      //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            className={styles.textarea}       
            placeholder="Type your message..."
            value={newMessage}
            onChange={handleInputChange}
            rows={1} // Set an initial number of rows
          />
          {/*<button onClick={handleSendMessage}>Send</button>*/}
          <button onClick={handleSendMessage} className={styles.button}>
            <SendIcon />
          </button>
        </div>
      </div>
    </Grid>
  );
}

export default VideoCallChat;